import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  HomeIcon,
  ShoppingBagIcon,
  ArrowRightOnRectangleIcon,
  UserCircleIcon
} from '@heroicons/react/24/outline';

const Sidebar = ({ closeSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  // دریافت اطلاعات کاربر
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'bg-blue-700 text-white' : 'text-blue-100 hover:bg-blue-700 hover:text-white';
  };

  const handleLinkClick = () => {
    if (closeSidebar) {
      closeSidebar();
    }
  };

  return (
    <div className="h-full flex flex-col bg-blue-800 text-blue-100" style={{ height: '100vh', overflow: 'hidden' }}>
      {/* لوگو - ثابت */}
      <div className="flex items-center justify-center h-16 bg-blue-900 flex-shrink-0">
        <h1 className="text-white text-xl font-bold">رقیب‌سنج</h1>
      </div>

      {/* منو - فقط محتوای منو scroll میشه */}
      <nav className="flex-1 overflow-y-auto px-2 py-4 space-y-2" style={{ flexGrow: 1, overflowY: 'auto' }}>
        <Link to="/" className={`flex items-center px-4 py-2 ${isActive('/')}`} onClick={handleLinkClick}>
          <HomeIcon className="h-6 w-6 ml-2" />
          داشبورد
        </Link>
        <Link to="/products" className={`flex items-center px-4 py-2 ${isActive('/products')}`} onClick={handleLinkClick}>
          <ShoppingBagIcon className="h-6 w-6 ml-2" />
          محصولات
        </Link>
        <Link to="/help" className={`flex items-center px-4 py-2 ${isActive('/help')}`} onClick={handleLinkClick}>
          <svg className="h-6 w-6 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          راهنما
        </Link>
      </nav>

      {/* کاربر و لاگ‌اوت - چسبیده به پایین */}
      <div className="p-4 border-t border-blue-700 mt-auto flex-shrink-0">
        {/* اطلاعات کاربر */}
        <div className="flex items-center gap-3 mb-3 px-3 py-2 bg-blue-700 rounded-lg">
          <UserCircleIcon className="h-8 w-8 text-white" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-white truncate">{user.name || 'کاربر'}</p>
            <p className="text-xs text-blue-200 truncate">{user.vendor_name || ''}</p>
          </div>
        </div>

        {/* دکمه لاگ‌اوت */}
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition font-medium text-sm"
        >
          <ArrowRightOnRectangleIcon className="h-5 w-5" />
          <span>خروج از حساب</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
